import { useCallback, useEffect, useState } from "react";
import { fetchFinancialPeriods } from "../../../api/accounting";
import { fetchBranches } from "../../../api/users";
import { monthStartIsoDate, todayIsoDate } from "./accountingUtils";

export function useAccountingReportFilters() {
  const [branches, setBranches] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [periodId, setPeriodId] = useState("");
  const [dateFrom, setDateFrom] = useState(monthStartIsoDate());
  const [dateTo, setDateTo] = useState(todayIsoDate());
  const [usePeriod, setUsePeriod] = useState(true);

  useEffect(() => {
    fetchBranches(true).then((rows) => {
      setBranches(rows || []);
      if (rows?.length) setBranchId(String(rows[0].id));
    });
  }, []);

  useEffect(() => {
    if (!branchId) return;
    fetchFinancialPeriods(branchId).then((rows) => {
      setPeriods(rows || []);
      const open = (rows || []).find((p) => p.status === "open");
      if (open) setPeriodId(open.id);
    });
  }, [branchId]);

  const reportParams = useCallback(() => {
    const params = {};
    if (branchId) params.branch_id = branchId;
    if (usePeriod && periodId) {
      params.period_id = periodId;
    } else {
      if (dateFrom) params.date_from = dateFrom;
      if (dateTo) params.date_to = dateTo;
    }
    return params;
  }, [branchId, periodId, dateFrom, dateTo, usePeriod]);

  return {
    branches,
    periods,
    branchId,
    setBranchId,
    periodId,
    setPeriodId,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    usePeriod,
    setUsePeriod,
    reportParams,
  };
}
